import { Badge, Flex, Text, Box, Image } from "@chakra-ui/react";
import { CalenderIcon } from "../../assets/icons/calenderIcon";
import { useTranslation } from "react-i18next";
import { formatDateToISO } from "@root/utils/date-helper";
import { REQUIREMENT_TYPE, ROUTE_NAMES } from "@root/constants";
import { useNavigate } from "react-router-dom";
import useMediaQ from "@root/hooks/useMediaQ";
import MobileWatchLater from "./MobileWatchLater";
import defaultThumbnail from "@root/assets/images/Course Thunbnail.png";

const DEFAULT_THUMBNAIL = defaultThumbnail;

export type CourseDetails = {
  courseTitle: string;
  requirements: string;
  dateAdded: string;
  duration: string;
};

export const WatchLater = ({ courseDetail }: { courseDetail: any }) => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { sm } = useMediaQ();
  const isMobile = !sm;

  if (isMobile) {
    return <MobileWatchLater courseDetail={courseDetail} />;
  }

  // Desktop version
  return (
    <Flex
      w="100%"
      gap="40px"
      borderRadius="12px"
      borderWidth="1px"
      borderColor="#CDD6DC"
      p="16px"
      flexDirection="row"
      justifyContent="space-between"
      alignItems="center"
    >
      {/* Course Image */}
      <Box
        w="180px"
        h="120px"
        flexShrink={0}
        borderRadius="12px"
        overflow="hidden"
      >
        <Image
          src={courseDetail?.thumbnail || DEFAULT_THUMBNAIL}
          objectFit="contain"
          w="100%"
          h="100%"
        />
      </Box>

      <Flex flexDirection="column" gap="12px" flex="1">
        <Text fontSize="16px" fontWeight="600">
          {courseDetail?.title}
        </Text>
        <Flex flexDirection="row" gap="8px" alignItems="center">
          <CalenderIcon />
          <Text fontSize="14px" fontWeight="400" color="#5C6670">
            {formatDateToISO(courseDetail?.updatedAt)}
          </Text>
          <Text fontSize="14px" fontWeight="400" color="#5C6670">
            {courseDetail?.duration}
          </Text>
          <Badge
            bg={"white"}
            color={
              courseDetail?.requirement === REQUIREMENT_TYPE.REQUIRED
                ? "#3A59D1"
                : "#FE6807"
            }
            borderRadius="16px"
            px="12px"
            py="4px"
            fontSize="12px"
            fontWeight="600"
            border={" 1px solid #CDD6DC"}
            w="fit-content"
            textTransform="none"
          >
            {courseDetail?.requirement === REQUIREMENT_TYPE.REQUIRED
              ? t("coursesPage.essentialRequired")
              : courseDetail?.requirement === REQUIREMENT_TYPE.OPTIONAL
              ? t("coursesPage.optionalRecommended")
              : ""}
          </Badge>
        </Flex>
      </Flex>

      <Flex
        flexDirection="row"
        gap="8px"
        alignItems="center"
        justifyContent="center"
        borderRadius="8px"
        bgColor="#1819B4"
        borderWidth="1px"
        p="6px 16px"
        cursor="pointer"
        onClick={() =>
          navigate(
            `${ROUTE_NAMES.JOURNALIST_COURSE_DETAIL}/${courseDetail?.id}`
          )
        }
      >
        <Text fontSize="14px" fontWeight="500" color="#FFFFFF">
          {t("myLearningDashboard.viewDetails")}
        </Text>
      </Flex>
    </Flex>
  );
};
